/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'run': {
    width: 16,
    height: 16,
    viewBox: '0 0 19.28 18.17',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M18.95 4a.5.5 0 00-.64.3l-.31 1a9.14 9.14 0 00-16.61.06.5.5 0 10.91.41 8.14 8.14 0 0115.19 1.11.49.49 0 00.16.23l.1.06a.51.51 0 00.17 0h.14l.11-.06a.49.49 0 00.16-.21l.81-2.24a.5.5 0 00-.19-.66zm-1.26 8.12a.5.5 0 00-.66.25 8.14 8.14 0 01-15.24-1.08v-.09l-.06-.08-.12-.12h-.52l-.09.07-.06.07-.05.09L0 13.5a.5.5 0 00.3.64.51.51 0 00.17 0 .5.5 0 00.53-.3l.35-1a9.14 9.14 0 0016.61-.06.5.5 0 00-.27-.63zm-6.1-2.42a.5.5 0 000-1H6.87a.5.5 0 100 1zm-6.35 0a.5.5 0 000-1h-.52a.5.5 0 100 1z" _fill="#c4c4c4"/><path pid="1" _fill="#74777a" d="M15.39 9.23l-5.06-4.06v8.12l5.06-4.06z"/></g></g>'
  }
})
